export type AppPath = "/" | "/transactions" | "/accounts" | "/bills" | "/goals" | "/settings";

const appPaths = new Set<AppPath>(["/", "/transactions", "/accounts", "/bills", "/goals", "/settings"]);

export function isAppPath(pathname: string) {
  const path = pathname !== "/" ? pathname.replace(/\/$/, "") : "/";
  return appPaths.has(path as AppPath);
}

export function normalizeAppPath(pathname: string): AppPath {
  const path = pathname !== "/" ? pathname.replace(/\/$/, "") : "/";
  return isAppPath(path) ? path as AppPath : "/";
}
